export default __webpack_public_path__ + "b7133a67a5085285651ab0f6ae3a4b6b.svg";